<form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">

  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">
          @if (!showTextBox) {
            <div (dblclick)="showTextbox()" class="">{{title}}</div>
          }
          <div>
            @if (showTextBox) {
              <input type="text"
                #titleTextBox
                [value]="title"
                id="titleTextBox"
                (blur)="closeTextbox($event.target)"
                (keyup.enter)="closeTextbox($event.target)" />
            }
          </div>

        </div>
        <div class="transaction-section-header-actions header-actions">
          <button class="hidden-xs asap-btn" kendoButton (click)="_onSave($event)">
            <span><img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" /></span>Process
          </button>
          <button class="hidden-xs asap-btn" kendoButton (click)="_onClear()">
            <span><img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" /></span>Clear
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row no-row-margin">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 small-pad-right">
      <div [ngClass]="isGeneralInformationExpanded == true ? 'transactionWidget' : 'transactionWidget-collapse'">
        <div class="row">
          <!-- <div class="col-12">
          <p class="titleStandardStyle">General Information</p>
        </div> -->

        <div class="col-12 sectionheader">
          <span class="titleStandardStyle">General Information</span>
          <span [ngClass]="isGeneralInformationExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
            class="float-right pointer-click"
          (click)="ExpandCollapseGeneralInfoWidget(isGeneralInformationExpanded)"></span>
        </div>


        @if (isGeneralInformationExpanded) {
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
            <div class="col-12 margin-top-10">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2"><label class="control-label">Date - Time</label></div>
                  <div class="col-10 transaction-input-fields">
                    <kendo-datetimepicker formControlName="date"
                      class="newFormControlWidth"
                      placeholder="Set Date and Time"
                      [disabled]="!_dateEnabled"
                      [format]="_datePickerFormat">
                    </kendo-datetimepicker>
                  </div>
                </div>
                <div class="transactions-stock-right-checkbox empty-small"></div>
              </div>
            </div>
            @if (_currentUser && _currentUser.isEnterprise) {
              <div class="col-12">
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <div class="col-2"><label class="control-label">Account</label></div>
                    <div class="col-10 transaction--input-fields">
                      <accounts-dropdown #kendo_combo_accounts
                        [formControl]="_selectedAccount"
                        class="bordered current-step newFormControlWidth"
                        [class.active]="_selectedAccount.value == null"
                        [required]="true">
                      </accounts-dropdown>
                    </div>
                  </div>
                  <div class="transaction--stock-right-checkbox empty-small"></div>
                </div>
              </div>
            }
            <sites-dropdown #kendo_combo_sites
              layout="transaction"
              [showAllSites]="true"
              [labelText]="'Site'"
              [inputContainerClass]="'transaction--input-fields'"
              formControlName="site"
              [placeholder]="'Choose a Site'"
              [textField]="'name'"
              [valueField]="'id'"
              class="bordered current-step newFormControlWidth"
              [required]="true">
            </sites-dropdown>
            <div class="col-12">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2"><label class="control-label">Assembly</label></div>
                  <!-- [disabled]="_form.get('site').value == null || (_form.get('purchaseOrder').value != null && _poPreference != 'notValidated')" -->
                  <div class="col-10 transaction-input-fields">
                    <kendo-combobox #kendo_combo_assembly [data]="_itemsFiltered" [filterable]="true"
                      (filterChange)="_handleItemsFilter($event)" [suggest]="true"
                      (valueChange)="_handleItemsChange($event)"
                      [formControl]="_selectedAssembly" [placeholder]="'Choose Assembly'"
                      [textField]="'number'" [valueField]="'id'" class="bordered newFormControlWidth"
                      required>
                    </kendo-combobox>
                    <a class="cursor-pointer" (click)="_openForm('stockItems')">
                      <img class="searchIcon"
                        [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'">
                      </a>
                      <!-- Fetch / Select-->
                      <span class="asap-input-icon">
                        <img class="addIcon"
                          (click)="_selectStocksHandler()"
                          [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                        </span>
                      </div>
                    </div>
                    <div class="transactions-stock-right-checkbox empty-small">
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group special_style_formgroup">
                    <div class="row">
                      <div class="col-2"><label class="control-label">Assembly Location</label></div>
                      <div class="col-10 transaction-input-fields">
                        <kendo-combobox #kendo_combo_locations [data]="_locationsFiltered"
                          [filterable]="true" (filterChange)="_handleLocationsFilter($event)"
                          [suggest]="true" [placeholder]="'Choose a Location'"
                          [formControl]="_selectedLocation" [textField]="'code'" [valueField]="'id'"
                          class="bordered newFormControlWidth" required>
                        </kendo-combobox>
                        <a class="cursor-pointer" (click)="_openForm('locations')">
                          <img class="searchIcon"
                            [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'">
                          </a>
                          <span class="asap-input-icon">
                            <img class="addIcon"
                              (click)="_selectLocationsHandler()"
                              [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                            </span>
                          </div>
                        </div>
                        <div class="transactions-stock-right-checkbox empty-small"></div>
                      </div>
                    </div>
                    <div class="col-12 margin-top-10">
                      <div class="form-group special_style_formgroup">
                        <div class="row flex-1">
                          <div class="col-2"><label class="control-label">Assembly Quantity</label></div>
                          <div class="col-10 transaction-input-fields">
                            <kendo-numerictextbox #quantity_input class="k-textbox writebox newFormControlWidth"
                              [min]="0"
                              (blur)="assemblyFillGrid()"
                              [formControl]="_quantity"
                              format="{{ quantityFormat }}"
                              (keydown.enter)="assemblyFillGrid()"
                            (keydown.Tab)="assemblyFillGrid()"></kendo-numerictextbox>
                            @if (isAssemblyMoreAvaialability) {
                              <span class="assembly-alert-badge">
                                You can only build {{assembleQuantity | quantityFormat}} from this Assembly
                              </span>
                            }
                          </div>
                        </div>
                        <div class="transactions-stock-right-checkbox">
                          <!-- <input type="checkbox" class="k-checkbox" [formControl]="_defaultQuantity"
                          kendoCheckBox />
                          <div class="transactions-stock-right-checkbox-text">Set as Default</div> -->
                        </div>
                      </div>
                      <div class="section-separator"></div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <!-- <div class="col-12 margin-top-10">
                    <div class="form-group special_style_formgroup display-flex">
                      <div class="row flex-1">
                        <div class="col-2"><label class="control-label">Assembly Quantity</label></div>
                        <div class="col-10 transaction-input-fields">
                          <kendo-numerictextbox #quantity_input class="k-textbox writebox newFormControlWidth"
                            [min]="0"
                            (blur)="assemblyFillGrid()"
                            [formControl]="_quantity"
                            format= "{{ quantityFormat }}"
                          (keydown.Tab)="assemblyFillGrid()"></kendo-numerictextbox>
                        </div>
                      </div>
                      <div class="transactions-stock-right-checkbox">
                      </div>
                    </div>
                    <div class="section-separator"></div>
                  </div> -->
                  <div class="col-12">
                    <div class="form-group special_style_formgroup display-flex">
                      <div class="row flex-1">
                        <!-- [class.disabled]="!_selectedStockItem.value || _quantity.value <= 0 || _itemType === 'standard' || _itemType === 'non-inventory'" -->
                        <div class="col-2">
                          <label class="control-label">
                            Inventory ID#
                          </label>
                        </div>
                        <div class="col-10 transaction-input-fields">
                          <!-- [class.disabled]="!_selectedStockItem.value || _quantity.value <= 0 || _itemType === 'standard' || _itemType === 'non-inventory'" -->
                          <input #inventory_id type="text" class="k-textbox writebox newFormControlWidth"
                            [placeholder]="'Inventory ID#'"
                            [formControl]="_inventoryCode" required />
                            <!-- [class.disabled]="!_selectedStockItem.value || _quantity.value <= 0 || _itemType === 'standard' || _itemType === 'non-inventory'" -->
                            <a class="cursor-pointer"
                              [attr.disabled]="true"
                              (click)="_quantitySubmitted()">
                              <img class="searchIcon"
                                [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'">
                              </a>
                            </div>
                          </div>
                          <div class="transactions-stock-right-checkbox">
                            <!-- <input type="checkbox" class="k-checkbox" [formControl]="_autoCodeGeneration"
                            kendoCheckBox />
                            <div class="transactions-stock-right-checkbox-text">Auto Generate</div> -->
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group special_style_formgroup display-flex">
                          <div class="row flex-1">
                            <!-- [class.disabled]="_itemType === 'standard' || _itemType === 'non-inventory'" -->
                            <div class="col-2">
                              <label class="control-label">
                                Expiration
                                Date
                              </label>
                            </div>
                            <div class="col-10 transaction-input-fields">
                              <!-- [class.disabled]="_itemType === 'standard' || _itemType === 'non-inventory'" -->
                              <kendo-datepicker #expiration_date
                                [formControl]="_expirationDate" [min]="_minDate"
                                class="newFormControlWidth" placeholder="Choose Date"
                                [formatPlaceholder]="_dateLabelFormat"
                              [format]="_datePickerFormat"></kendo-datepicker>
                            </div>
                          </div>
                          <div class="transactions-stock-right-checkbox empty">
                            <div class="transactions-stock-right-checkbox empty-small"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group special_style_formgroup display-flex">
                          <div class="row flex-1">
                            <div class="col-2"><label class="control-label">Assemble Cost</label></div>
                            <div class="col-10 transaction-input-fields">
                              <kendo-numerictextbox #cost_input [formControl]="_cost"
                                class="k-textbox writebox newFormControlWidth" [min]="0"
                              [format]="_costFormat"></kendo-numerictextbox>
                            </div>
                          </div>
                          <div class="transactions-stock-right-checkbox empty">
                            <div class="transactions-stock-right-checkbox empty-small"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group special_style_formgroup display-flex">
                          <div class="row flex-1">
                            <div class="col-2"><label class="control-label">Transaction Notes</label></div>
                            <div class="col-10 transaction-input-fields">
                              <input type="text" class="k-textbox writebox newFormControlWidth"
                                formControlName="notes" placeholder="Transaction Notes.." />
                              </div>
                            </div>
                            <div class="transactions-stock-right-checkbox empty">
                              <div class="transactions-stock-right-checkbox empty-small"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="transactionWidget with-grid numericboxtab">
                  <div class="flex-space-between transaction-grid-header-wrapper">
                    <p class="titleStandardStyle">Selected Items</p>
                    <div class="transaction-grid-top-actions">
                      <div class="transaction-grid-top-actions-radio">
                        <input type="radio" id="new-to-old-items" name="transaction-duration" value="new"
                          [formControl]="_sortingSelected" kendoRadioButton />
                          <label class="k-radio-label" [for]="'new-to-old-items'">Newest To Oldest</label>
                        </div>
                        <div class="transaction-grid-top-actions-radio">
                          <input type="radio" id="old-to-new-items" name="transaction-duration" value="old"
                            [formControl]="_sortingSelected" kendoRadioButton />
                            <label class="k-radio-label" [for]="'old-to-new-items'">Oldest To Newest</label>
                          </div>
                        </div>
                      </div>

                      <kendo-grid [data]="_inventoryGridData" [scrollable]="'none'"
                        class="transaction-grid"
                        (remove)="_removeHandler($event)">

                        <kendo-grid-column field="itemNumber" title="Stock Item #">
                        </kendo-grid-column>

                        <kendo-grid-column field="description" title="Stock Description">
                        </kendo-grid-column>

                        @if (isSubstitute) {
                          <kendo-grid-column field="SubstituteItemsFiltered" title="Substitute Stock Item #">
                            <ng-template kendoGridCellTemplate let-dataItem>
                              <kendo-combobox #kendo_combo_locations style="width:100%"
                                [data]="dataItem.SubstituteItemsFiltered"
                                [filterable]="true"
                                (valueChange)="_changeSubstitute($event, dataItem)"
                                [suggest]="true"
                                [placeholder]="'Select a Substitute Stock Item'"
                                [textField]="'number'" [valueField]="'id'"
                                [disabled]="dataItem.isDisabled">
                              </kendo-combobox>
                            </ng-template>
                          </kendo-grid-column>
                        }

                        <kendo-grid-column field="qtyAssembly" title="Quantity Needed Per Assembly">
                        </kendo-grid-column>

                        <kendo-grid-column field="qtyTransaction" title="Quantity Needed For This transaction">
                        </kendo-grid-column>

                        <!-- <kendo-grid-column field="subStockNumber" title="Substitute Stock item#">
                      </kendo-grid-column> -->

                      <kendo-grid-column field="fromLocation" title="From Location">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <kendo-combobox #kendo_combo_locations style="width:100%"
                            [data]="dataItem.fromLocationFiltered"
                            [filterable]="true"
                            (valueChange)="_selectedItemLocationChange($event, dataItem)"
                            [value]="dataItem.selectedFromLocation"
                            [suggest]="true"
                            [placeholder]="'Choose a Location'"
                            [textField]="'locationCode'"
                            [valueField]="'locationCode'"
                            class="bordered">
                          </kendo-combobox>
                        </ng-template>
                      </kendo-grid-column>

                      <kendo-grid-column [width]="400" field="inventoryCode" title="Inventory ID#">

                        <ng-template kendoGridCellTemplate let-dataItem>
                          @if (!dataItem.isSerialOrBatchOrSrwthquanty) {
                            <kendo-combobox #kendo_combo_locations style="width:100%"
                              [data]="$safeNavigationMigration(dataItem.selectedFromLocation?.inventories)"
                              [value]="dataItem.selectedInventory"
                              [filterable]="true"
                              (valueChange)="_selectedItemInventoryChange($event, dataItem)"
                              [suggest]="true"
                              [placeholder]="'Choose inventory number'" [textField]="'inventoryNumber'"
                              [valueField]="'inventoryNumber'"
                              class="bordered">
                            </kendo-combobox>
                          }

                          @if (dataItem.isSerialOrBatchOrSrwthquanty) {
                            <kendo-multiselect
                              #kendo_multi_locations
                              style="width:100%"
                              (dblclick)="_selectInventoryIdsOpen($event, dataItem)"
                              (click)="_selectInventoryIdsOpen($event, dataItem)"
                              [data]="$safeNavigationMigration(dataItem.selectedFromLocation?.inventories)"
                              [textField]="'inventoryNumber'"
                              [valueField]="'inventoryNumber'"
                              [filterable]="true"
                              [(value)]="dataItem.selectedInvIds"
                              (valueChange)="_selectedListInventoryChange($event, dataItem)"
                              [placeholder]="'Choose inventory number'"
                              class="bordered custom-non-selectable">
                              <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                <input type="checkbox" class="k-checkbox" [checked]="false">
                                <label class="k-checkbox-label">
                                  {{ dataItem.title }}
                                </label>
                              </ng-template>
                            </kendo-multiselect>
                          }
                        </ng-template>


                      </kendo-grid-column>

                      <!-- <asap-barcode-generation
                      [class.disabled]="dataItem.itemType === 'standard' || dataItem.itemType === 'non-inventory'"
                      class="transaction-grid-barcode-generator" [placeholder]="'Inventory ID#'"
                      [entityName]="'inventories'"
                      [quantity]="dataItem.itemType === 'serial' ? dataItem.quantity : 1"
                      [value]="dataItem.inventoryCode"
                      [icon]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'">
                    </asap-barcode-generation> -->
                    <!-- <button *ngIf="!isAssemblyMoreAvaialability"
                    class="hidden-xs asap-btn" kendoButton
                    (click)="_selectInventoryIdsOpen()">
                    Choose Inventories
                  </button> -->

                  <kendo-grid-column field="quantity" title="Available Quantity">
                  </kendo-grid-column>

                  <kendo-grid-column field="qtyIssued" title="Quantity Issued">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <kendo-numerictextbox style="width: 100%;" class="transaction-receive-grid-quantity"
                        format="{{ quantityFormat }}"
                        [value]="dataItem.qtyIssued" [disabled]="true" [min]="0">
                      </kendo-numerictextbox>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-command-column title="Action">
                    <ng-template kendoGridCellTemplate>
                      <div kendoGridRemoveCommand class="asap-grid-remove">
                        <div class="asap-grid-remove-icon">
                          <img src="/assets/menu/enterprise/remove-icon.svg" />
                        </div>
                        <div class="asap-grid-remove-text">
                          Delete
                        </div>
                      </div>
                    </ng-template>
                  </kendo-grid-command-column>
                </kendo-grid>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              @if (_invalidForm) {
                <asap-forms-validation-summary [form]="_form" [page]="'kitting'">
                </asap-forms-validation-summary>
              }
            </div>
          </div>
          @if (_isDialiog) {
            <asap-dialog-layout
              [componentName]="_dialogComponentName"
              [data]="_dialogModel"
              (closeDialog)="_closeDialog($event)">
            </asap-dialog-layout>
          }
        </form>

        @if (_barcodePopupActive) {
          <kendo-window class="barcode-generator-popup" title="Barcode Management For Serial Items"
            (close)="_barcodePopupClose()">
            <form [formGroup]="_barcodePopupForm" class="form_style">
              <div class="col-12">
                <div class="row special_row_margin">
                  <div class="col-12 special_col_padding">
                    <div class="border_sections margin-top-4">
                      <div class="k-block">
                        <h2>Inventory ID#</h2>
                        <div class="right_buttons">
                          <br />
                          <div class="row mx-0 bottom_buttons">
                            <button class="asap-btn" kendoButton (click)="_onBarcodePopupClear()">
                              <span><img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" /></span>Clear
                            </button>
                            <button class="asap-btn" kendoButton [disabled]="_barcodePopupForm.invalid"
                              (click)="_onBarcodePopupSave()">
                              <span><img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" /></span>Save
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="row row_padding">
                        <div class="col-12">
                          @for (field of _barcodePopupFormFields; track field) {
                            <div class="form-group from_but_container special_style_formgroup display-flex mb-3">
                              <input type="text" class="k-textbox writebox" [placeholder]="'Inventory ID#'"
                                [formControlName]="field" />
                                <a class="cursor-pointer" (click)="_barcodePopupGenerateBarcode(field)">
                                  <img class="searchIcon"
                                    [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'">
                                  </a>
                                  <a class="cursor-pointer ml-1" (click)="_onBarcodePopupClear(field)">
                                    <img class="searchIcon"
                                      [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" />
                                    </a>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </kendo-window>
              }

              @if (_selectInevtoryIdsPopup) {
                <kendo-window class="barcode-generator-popup" title="SELECT INVENTORY ID #"
                  (close)="_selectInventoryIdsClose()">
                  <form [formGroup]="_barcodePopupForm" class="form_style">
                    <div class="col-12">
                      <div class="row special_row_margin">
                        <div class="col-12 special_col_padding">
                          <div class="border_sections margin-top-4">
                            <div class="k-block">
                              <h6>
                                Quantity Needed: {{_serialItemSelected[0].qtyTransaction}}
                              </h6>
                              <div class="right_buttons">
                                <br />
                                <div class="row bottom_buttons">
                                  <kendo-grid [data]="_serialItemSelected" [scrollable]="'none'" class="transaction-grid">
                                    <kendo-grid-column field="inventoryCode" title="Inventory ID#">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <kendo-multiselect #kendo_multi_locations
                                          style="width:100%"
                                          [data]="$safeNavigationMigration(dataItem.selectedFromLocation?.inventories)"
                                          [textField]="'inventoryNumber'"
                                          [valueField]="'inventoryNumber'"
                                          [valuePrimitive]="true"
                                          [filterable]="true"
                                          [(value)]="_selectedSeriaslListIds"
                                          (valueChange)="_selectedListInventoryChange($event, dataItem)" [placeholder]="'Choose inventory number'"
                                          class="bordered">
                                        </kendo-multiselect>
                                        <br>
                                          <button class="asap-btn" kendoButton
                                            (click)="_selectInventoryIdsSave($event, dataItem)">
                                            <span><img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" /></span>
                                            Save & Close
                                          </button>
                                        </ng-template>
                                      </kendo-grid-column>
                                    </kendo-grid>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </kendo-window>
                }

                @if (_showLocationsGrid) {
                  <kendo-window
                    title="{{'Add Location to the Receive Transaction'}}"
                    (close)="_closeLocationsWindow()"
                    class="addFromLibrary">
                    <div class="greytabtop">
                      <button kendoButton
                        class="topRightButtonSelect"
                        (click)="_returnSelectedLocationsHandler($event)">
                        Select & Return
                      </button>
                    </div>
                    @if (_locationsGridColumns) {
                      <asap-grid-layout
                        [page]="'locations'"
                        [entityName]="'location'"
                        [sortingEnabled]="true"
                        [enableSiteSelection]="false"
                        [resolver]="_getLocations"
                        [orderEnable]="true"
                        class="ListGrid"
                        [selectable]="true"
                        [pagingEnabled]="true"
                        [selectByField]="_selectedCallback"
                        [filteringEnable]="true"
                        [addNewFormEnabled]="false"
                        [deletedEnabled]="false"
                        [headerEnable]="true"
                        (onRowSelectionChanges)="_onLocationRowSelectionChanges($event)"
                        [singleSelect]="true">
                        @for (column of _locationsGridColumns; track column) {
                          @if (column.selected) {
                            @if (!column.isTemplate) {
                              <ng-template pageListColumn
                                [field]="column.field"
                                [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                [type]="column.type"
                                let-item>
                                @if (column.type == 'date' && column.isCustomField == false && column.field != 'notes') {
                                  {{ item[column.field] | dateFormat }}
                                }
                                @if (column.type != 'date' && column.isCustomField == false && column.field != 'notes') {
                                  @if (column.field != 'notes' && column.field !='site.code') {
                                    <label>
                                      {{column.field | complexFieldValue: item}}
                                    </label>
                                  }
                                  @if (column.field =='site.code') {
                                    <label>
                                      {{item.site == null ? 'All Sites' : column.field | complexFieldValue: item}}
                                    </label>
                                  }
                                }
                                @if (column.isCustomField == true) {
                                  {{item[column.field]}}
                                }
                              </ng-template>
                            }
                            @if (column.isTemplate) {
                              <ng-template pageListColumn
                                [field]="column.field"
                                [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                [type]="column.type"
                                let-item>
                                @if (column.type == 'date' && column.isCustomField == false && column.field != 'notes') {
                                  {{ item[column.field] | dateFormat }}
                                }
                                @if (column.type != 'date' && column.isCustomField == false && column.field != 'notes') {
                                  @if (column.field != 'notes' && column.field !='site.code') {
                                    <label>
                                      {{column.field | complexFieldValue: item}}
                                    </label>
                                  }
                                  @if (column.field =='site.code') {
                                    <label>
                                      {{item.site == null ? 'All Sites' : column.field | complexFieldValue: item}}
                                    </label>
                                  }
                                }
                                @if (column.isCustomField == true) {
                                  {{item[column.field]}}
                                }
                              </ng-template>
                            }
                          }
                        }
                      </asap-grid-layout>
                    }
                  </kendo-window>
                }

                @if (_showStocksGrid) {
                  <kendo-window
                    title="{{'Add Stock to the Receive Transaction'}}"
                    (close)="_closeStocksWindow()"
                    class="addFromLibrary">
                    <div class="greytabtop">
                      <button kendoButton
                        class="topRightButtonSelect"
                        (click)="_returnSelectedStocksHandler($event)">
                        Select & Return
                      </button>
                    </div>
                    @if (_stockItemsGridColumns) {
                      <asap-grid-layout
                        [page]="'stockItems'"
                        [entityName]="'stock'"
                        [sortingEnabled]="true"
                        [enableSiteSelection]="false"
                        [resolver]="_getStockItems"
                        [orderEnable]="true"
                        class="ListGrid"
                        [selectable]="true"
                        [singleSelect]="true"
                        [pagingEnabled]="true"
                        [selectByField]="_selectedCallback"
                        [filteringEnable]="true"
                        [addNewFormEnabled]="false"
                        [deletedEnabled]="false"
                        [headerEnable]="true"
                        [enableSiteSelection]="false"
                        (onRowSelectionChanges)="_onStockRowSelectionChanges($event)">
                        @for (column of _stockItemsGridColumns; track column) {
                          @if (column.selected) {
                            @if (column.isTemplate) {
                              <ng-template pageListColumn [field]="column.field"
                                [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type" let-item>
                                @if (column?.type == 'date') {
                                  {{ item[column.field] | dateFormat }}
                                }
                                @if (column.isCustomField == true) {
                                  {{item[column.field]}}
                                }
                                @if (column.field == 'stockItemSites.account.name') {
                                  {{getAccountNames(item.stockItemSites)}}
                                }
                                @if (column.formatType == costPriceFormatType) {
                                  {{column.field | complexFieldValue: item | costFormat}}
                                }
                                @if (column.formatType == quantityFormatType ) {
                                  {{column.field | complexFieldValue: item | quantityFormat}}
                                }
                                @if (column.field =='site.code' || column.field == 'site.name') {
                                  {{item.site == null ? 'All Sites' : column.field | complexFieldValue: item}}
                                }
                              </ng-template>
                            }
                            @if (!column.isTemplate ) {
                              <!--&& _currentUser.isEnterprise == false  && column.field != 'quantityPerAccount' -->
                              <ng-template pageListColumn [field]="column.field"
                                [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type" let-item>
                                @if (column.field == 'markupType') {
                                  {{ getMarkupType(item,column.field) }}
                                }
                                @if (column.type == 'date' && column.isCustomField == false) {
                                  {{ item[column?.field] | dateFormat }}
                                }
                                @if (column.type != 'date' && column.type != 'image' && column.isCustomField == false
                                  && column.formatType != quantityFormatType && column.formatType != costPriceFormatType) {
                                  @if (column.field == 'notes') {
                                    <a style="cursor: pointer;" (click)="_showStockItemNotesWindow(item.id)">
                                      <img class="notesIcon" [src]="'/assets/menu/'+ _theme +'/note-icon.svg'" />
                                    </a>
                                  }
                                  @if (column.field != 'notes') {
                                    <label>
                                      {{column.field | complexFieldValue: item}}
                                    </label>
                                  }
                                }
                                @if (column.isCustomField == true) {
                                  {{item[column.field]}}
                                }
                                @if (column.field == 'category.categoryFiles.file.thumbnail' && column.type == 'image') {
                                  @if (item.category.categoryFiles != undefined) {
                                    <div class="Category-icon">
                                      <img [src]="displayCatImage(column.field | complexFieldValue: item,item.category.categoryFiles)"
                                        appImagePopup width="100" />
                                      </div>
                                    }
                                  }
                                  @if (column.field == 'stockItemFiles.file.thumbnail' && column.type == 'image') {
                                    @if (item.stockItemFiles != undefined) {
                                      <div class="Category-icon">
                                        <img [src]="displayStockImage(column.field | complexFieldValue: item,item.stockItemFiles)"
                                          width="100" appImagePopup />
                                        </div>
                                      }
                                    }
                                  </ng-template>
                                }
                              }
                            }
                          </asap-grid-layout>
                        }
                      </kendo-window>
                    }


                    @if (_barcodePopupActive || _selectInevtoryIdsPopup || _showStockItemFileNotes) {
                      <div class="k-overlay"
                      ></div>
                    }
                    @if (_showStockItemFileNotes) {
                      <kendo-window
                        title="Stock Notes"
                        (close)="_closeStockItemNotesWindow()"
                        class="addFromLibrary">
                        @if (!_currentUser.isEnterprise) {
                          <div
                            class="borderedNotesContainer">
                            <note #note
                              [_pageState]="3"
                              [_model]="_stockItemNotesModel"
                              [_page]="'stockItems'">
                            </note>
                          </div>
                        }
                      </kendo-window>
                    }
